module.exports = __webpack_public_path__ + "static/img/yhg_code.38e42be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/yhg_code.jpg
// module id = 79gq
// module chunks = 11